/** 内置颜色 */
export const BUILT_IN_COLOR = ['green', 'red', 'orange'];

/**
 * 组件的props
 */
export const props = {
  /**
   * 标签文本内容
   * @default ''
   */
  content: {
    type: String,
    default: '',
  },
  /**
   * 标签图标，附加在文本前
   */
  icon: {
    type: [String, Object],
    default: null,
  },
  /**
   * 标签大小
   * @default 'small'
   */
  size: {
    type: String,
    default: 'small',
    validator: (value: string) => ['small', 'medium'].includes(value),
  },
  /**
   * 标签颜色，支持内置颜色和自定义颜色
   * @default 'green'
   */
  color: {
    type: String,
    default: 'green',
    validator: (value: string) => {
      // 内置颜色校验
      if (BUILT_IN_COLOR.includes(value)) return true;
      // 16进制颜色校验
      if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value)) return true;
      // RGB颜色校验
      if (/^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/.test(value)) return true;
      return false;
    },
  },
  /**
   * 样式类型
   * @default 'dark'
   */
  variant: {
    type: String,
    default: 'dark',
    validator: (value: string) => ['dark', 'light-outline'].includes(value),
  },
};
